module.exports = __webpack_public_path__ + "09_mole.71d5fe69.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer2/09_mole.png
// module id = Whlj
// module chunks = 0